/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menurescan1Inputs */

const en_menurescan1 = /** @type {(inputs: Menurescan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read again`)
};

const de_menurescan1 = /** @type {(inputs: Menurescan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu einlesen`)
};

/**
* | output |
* | --- |
* | "Read again" |
*
* @param {Menurescan1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menurescan1 = /** @type {((inputs?: Menurescan1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menurescan1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menurescan1(inputs)
	return de_menurescan1(inputs)
});
export { menurescan1 as "menuRescan" }